//import services from '../services/service'; // Service Class
import Activity from './activity.js'; //Activity Class
//let service = new services();

export default {
    name: 'Utility Resource',
    props: {
        //currentActivity:Object,
        //wishlist_product: Object,
    },
    mixins: [Activity],
    data () {
      return {
        wishlist_folder:{},
        wishlist_product:{},
      }
  },

    methods: {
        addToWishlist(){
            //set activity
            this.activity.activity_record_activity = 0; //do not record
            this.activity.activity_user_module = 1; //user
            this.activity.activity_user_module_id = this.user.user_id;
            this.activity.activity_id = 0;
            this.activity.activity_action_type = 48,//post activity
            this.activity.activity_module = 16; //product item module
            this.activity.activity_module_id = this.wishlist_product.product_item_id;
            this.activity.activity_caption = '';
            //ams-model
            this.activity.activity_module_action_type = 2; //add item to folder
            //set folder item
            let folder_payload = {
                folder_item_module: 16, //product item module
                folder_item_module_id: this.wishlist_product.product_item_id,
            }
            //set store
            this.activity.activity_data_store_id = 9; //wislist
            //
            if((Object.keys(this.wishlist_folder).length == 0)){ //set folder details to create a new folder
                folder_payload.folder_item_folder_name = "General";
                folder_payload.folder_item_folder_descr = "General Wishlist";
                folder_payload.folder_item_folder_type = 7; //wishlist
                folder_payload.folder_item_folder_owner_module = 1; //user
                folder_payload.folder_item_folder_owner_module_id = this.user.user_id;
                folder_payload.folder_item_folder_created_by = this.user.user_id;
            }else{
                folder_payload.folder_item_folder = this.wishlist_folder.folder_id;
            }
            //
            this.activity.activity_module_data = folder_payload,
            //
            this.setActivity();
        }
    },
    created: function(){}
}


// WEBPACK FOOTER //
// ./src/resources/utility.js